import store from "@/store";

export const initVuex = () => {
    store.dispatch('user/INIT_USER').then(_ => {
    }).catch(_ => {
    })
    store.dispatch('web/INIT_WEB').then(_ => {
    }).catch(_ => {
    })
}
